import { render, staticRenderFns } from "./iconComp.vue?vue&type=template&id=143ae24c&"
import script from "./iconComp.vue?vue&type=script&lang=js&"
export * from "./iconComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports